'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { Text } from '@portals/ui-kit';
import { useLocalStorage } from '@portals/external-services-header/lib/_hooks/use-local-storage';
import { EButtonColor } from '@/_kit/button/_types';
import { ELoginButtonPagePosition } from '@/_constants/analytics';
import { BasketImage } from '@/_components/basket-image';
import { LoginButton } from '../login-button';
import { TPreviewWithImageConfig } from './_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'PreviewWithImage';

export const PreviewWithImage = ({
  title,
  startSelling,
  buttonTitle,
  image,
}: TPreviewWithImageConfig) => {
  const translations = useTranslations();
  const { mobileWebView } = useLocalStorage();

  return (
    <section
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--mobile-web-view`]: mobileWebView,
      })}
    >
      <div className={cn(`${BLOCK_NAME}__content-wrapper`)}>
        <div className={cn(`${BLOCK_NAME}__content`)}>
          <div className={cn(`${BLOCK_NAME}__title`)}>
            <Text
              color="white"
              size="headline-l"
              text={translations(title)}
              tagType="h1"
            />
          </div>
          <Text
            color="white"
            size="title-s"
            text={translations(startSelling)}
          />
          <div className={cn(`${BLOCK_NAME}__button`)}>
            <LoginButton
              color={EButtonColor.PINK}
              positionOnPage={ELoginButtonPagePosition.UP}
              text={translations(buttonTitle)}
            />
          </div>
        </div>
        <div className={cn(`${BLOCK_NAME}__single-image`)}>
          <BasketImage alt="preview-image" fill sizes="100%" src={image} />
        </div>
      </div>
    </section>
  );
};
